import React from 'react';

import { parseISO, format } from 'date-fns';
import pt from 'date-fns/locale/pt-BR';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';


/** 
 * InstrucoesPagamentoPix
 * @param props: { open, onClose, pixText, pixExpirationDate, pixLinkQrCode }
*/
export default function InstrucoesPagamentoPix(props) {
  const transformDate = (data, formatData) => {
    if (!data) {
      return '';
    }
    var dateAt = parseISO(data);
    if (!formatData) {
      formatData = "dd 'de' MMMM ' às ' HH:mm 'hrs' ";
    }
    return format(dateAt, formatData, { locale: pt });
  };

  const copiar = () => {
    setTimeout(() => alert('Copiado para aréa de transferência'), 300);
    navigator.clipboard.writeText(props.pixText);
  };

  return (
    <Dialog
      open={props.open}
      keepMounted={false}
      onClose={() => props.onClose()}
      disableEscapeKeyDown
      aria-labelledby='alert-dialog-slide-title'
      aria-describedby='alert-dialog-slide-description'
    >
      <DialogContent>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <h3>Instruções de Pagamento</h3>
          <ul>
            <li>Escaneie o QR code com o aplicativo do seu banco.</li>
            <li>Ou Copie e cole o código PIX</li>
            <li>
              Validade:{' '}
              {transformDate(props.pixExpirationDate, 'dd/MM/yyyy HH:mm')}
            </li>
          </ul>
          <img
            src={props.pixLinkQrCode}
            alt='QRCode do PIX'
            height='100'
            width='100'
          />

          <span>
            Código{' '}
            <span
              onClick={() => copiar()}
              style={{ cursor: 'pointer', fontWeight: 'bold' }}
            >
              copia e cola
            </span>
          </span>
          <div className='text-info'>
            Após o pagamento aguarde até 5 minutos para a confirmação.
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <button
          className='button'
          onClick={() => props.onClose()}
        >
          Fechar
        </button>
      </DialogActions>
    </Dialog>
  );
}
